import { render, staticRenderFns } from "./role-info.vue?vue&type=template&id=e545bf04&"
import script from "./role-info.vue?vue&type=script&lang=js&"
export * from "./role-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "role-info.vue"
export default component.exports